import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { Row, Col, Form } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import Pagination from 'react-js-pagination'
import { DebounceInput } from 'react-debounce-input'

const ListingReportsFunds = ({
  data,
  columns,
  pagination,
  stateFilters,
  handleFilterChange,
  fiscalYears
}) => {
  const { t } = useTranslation()

  return (<>
    <Row>
      <Col>
        <Row className="d-flex justify-content-between">
          <Col md="3">
            <Form.Group>
              <Form.Label>{t('label:records per page')}:</Form.Label>
              <Form.Control
                as="select"
                value={stateFilters.per_page}
                onChange={(e) =>
                  handleFilterChange({ per_page: e.target.value, page: 1 })
                }
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md="3">
            <Form.Group>
              <Form.Label>Ano Fiscal:</Form.Label>
              <Form.Control
                as="select"
                value={stateFilters.fiscal_year}
                onChange={(e) =>
                  handleFilterChange({ fiscal_year: e.target.value, page: 1 })
                }
              >
                <option disabled selected>Selecione o Ano fiscal</option>
                {fiscalYears.map(year => (
                  <option>{year}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={3} className="ml-2">
            <Form.Group>
              <Form.Label>{t('label:search')}:</Form.Label>
              <DebounceInput
                element={Form.Control}
                debounceTimeout={500}
                value={stateFilters.search}
                onChange={(e) =>
                  handleFilterChange({ search: e.target.value, page: 1 })
                }
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <BootstrapTable
              columns={columns}
              id="funds-report-table"
              keyField="index"
              data={data}
              bordered hover responsive striped
              rowStyle={{ fontSize: '13px' }}
              noDataIndication="--"
              classes="table-condensed w-auto"
              wrapperClasses='table-responsive'
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Trans i18nKey="label:interpolateShowingRecords">
              Showing {{ from: pagination.from || '0' }} to{' '}
              {{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
              records
            </Trans>
          </Col>
          <Col className="d-flex justify-content-end">
            <Pagination
              activePage={pagination.current_page}
              itemsCountPerPage={pagination.per_page}
              totalItemsCount={pagination.total}
              pageRangeDisplayed={5}
              onChange={(page) => handleFilterChange({ page })}
              itemClass="page-item"
              linkClass="page-link"
              prevPageText="‹"
              nextPageText="›"
            />
          </Col>
        </Row>
      </Col>
    </Row>
  </>)
}

export default ListingReportsFunds